import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73dbef9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ion-text-center" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { style: {"height":"400px","width":"100%"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "cropped-pet-photo-container",
  style: {"height":"100px","width":"200px","margin":"0 auto","overflow":"hidden"}
}, null, -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "ion-text-center ion-margin-top" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "ion-text-center" }
const _hoisted_15 = { class: "cropper-wrap-box" }
const _hoisted_16 = { class: "ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_line = _resolveComponent("v-line")!
  const _component_v_group = _resolveComponent("v-group")!
  const _component_v_circle = _resolveComponent("v-circle")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { color: "primary" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPrev(_ctx.stickerId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.canvas.croppedImgDataURL ? _ctx.t('rembg') : _ctx.t('createWhatsAppSticker')), 1)
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  fill: "solid",
                  color: "secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goNext()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('next')) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.arrowForward
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.photos.length > 0 && !_ctx.canvas.croppedImgDataURL]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        (_ctx.photos.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, "1. " + _toDisplayString(_ctx.t('uploadYourPetPhoto')), 1),
              _createVNode(_component_ion_card, { class: "spin photo-card ion-align-items-center ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_fab_button, {
                    size: "large",
                    class: "centered-fab-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.takePhoto()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.camera }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_4, "2. " + _toDisplayString(_ctx.t('cropYourPetPhoto')), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    id: "sticker-pet-photo",
                    src: _ctx.photos[0].base64Data
                  }, null, 8, _hoisted_6)
                ]),
                _hoisted_7
              ], 512), [
                [_vShow, _ctx.canvas.croppedImgDataURL == '']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment, {
                      mode: "ios",
                      modelValue: _ctx.rembgMode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rembgMode) = $event)),
                      onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onRembgModeChanged()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment_button, {
                          value: "original",
                          layout: "icon-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('useOriginal')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment_button, {
                          value: "manual",
                          layout: "icon-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.handRightOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('manualRembg')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment_button, {
                          value: "auto",
                          layout: "icon-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.layersOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('autoRembg')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("img", {
                    style: {"max-height":"400px","object-fit":"contain"},
                    src: _ctx.canvas.croppedImgDataURL
                  }, null, 8, _hoisted_8)
                ], 512), [
                  [_vShow, _ctx.rembgMode == 'original']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('rembgFriendlyReminder')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ion_spinner),
                    _createElementVNode("p", null, _toDisplayString(_ctx.t('processingImg')), 1),
                    _createVNode(_component_ion_progress_bar, {
                      value: _ctx.canvas.rembgLoadingPercent
                    }, null, 8, ["value"])
                  ], 512), [
                    [_vShow, _ctx.canvas.loadingRembgImg]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("img", {
                      id: "rembg-pet-photo",
                      src: _ctx.canvas.rembgImgDataURL
                    }, null, 8, _hoisted_11)
                  ], 512), [
                    [_vShow, !_ctx.canvas.loadingRembgImg]
                  ])
                ], 512), [
                  [_vShow, _ctx.rembgMode == 'auto']
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  (_ctx.canvas.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_ion_spinner),
                        _createElementVNode("p", null, _toDisplayString(_ctx.t('loading')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("div", null, [
                          _createElementVNode("h2", _hoisted_14, "1. " + _toDisplayString(_ctx.t('relocateAnchorPoint')), 1)
                        ], 512), [
                          [_vShow, _ctx.canvas.isRelocatingAnchorPoint]
                        ]),
                        _withDirectives(_createVNode(_component_ion_toolbar, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_buttons, { slot: "start" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  fill: "solid",
                                  slot: "icon-only",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetEraseImage()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, "2. " + _toDisplayString(_ctx.t('startOutlineDraw')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, !_ctx.canvas.isRelocatingAnchorPoint]
                        ]),
                        _createElementVNode("div", {
                          class: "cropper-container cropper-bg",
                          style: _normalizeStyle({ width: `${_ctx.canvas.sceneWidth}px`, height: `${_ctx.canvas.sceneHeight}px` })
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_v_stage, {
                              class: "cropper-canvas",
                              style: _normalizeStyle({
                    transform: `translate(
                      0px,
                      ${(_ctx.canvas.sceneHeight - _ctx.getCanvasHeight()) / 2}px
                    )`
                  }),
                              ref: "stageRef",
                              config: {
                    width: _ctx.getCanvasWidth(),
                    height: _ctx.getCanvasHeight(),
                  },
                              onMousedown: _ctx.handleStageMouseDown,
                              onTouchstart: _ctx.handleStageMouseDown,
                              onMousemove: _ctx.handleStageMouseMove,
                              onTouchmove: _ctx.handleStageMouseMove,
                              onMouseup: _ctx.handleStageMouseUp,
                              onTouchend: _ctx.handleStageMouseUp
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_layer, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_image, {
                                      config: {
                      scaleX: _ctx.getCanvasPetImgScale(),
                      scaleY: _ctx.getCanvasPetImgScale(),
                      x: 0,
                      y: 0,
                      fill: `linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7) )`,
                      opacity: _ctx.canvas.isRelocatingAnchorPoint ? 0.9 : 0.7,
                      image: _ctx.canvas.petImg,
                      perfectDrawEnabled: false,
                      shadowForStrokeEnabled: false,
                    }
                                    }, null, 8, ["config"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_layer, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_group, { config: { name: 'outlinedImgGroup' } }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_image, {
                                          config: {
                        id: 'outlinedImg',
                        scaleX: _ctx.getCanvasPetImgScale(),
                        scaleY: _ctx.getCanvasPetImgScale(),
                        x: 0,
                        y: 0,
                        image: _ctx.canvas.petImg,
                        //perfectDrawEnabled: false,
                        //shadowForStrokeEnabled: false,
                      }
                                        }, null, 8, ["config"]),
                                        _createVNode(_component_v_line, {
                                          config: {
                        points: _ctx.canvas.erasedPoints,
                        fill: 'black',
                        stroke: 'black',
                        strokeWidth: 1,
                        //tension: 10,
                        shadowBlur: 10,
                        shadowOpacity: 1,
                        closed: true,
                        globalCompositeOperation: 'destination-in',
                      }
                                        }, null, 8, ["config"])
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvas.lines, (line, i) => {
                                      return (_openBlock(), _createBlock(_component_v_line, {
                                        key: i,
                                        config: {
                      //tension: 5,
                      stroke: 'red',
                      strokeWidth: 3,
                      points: line.points,
                      //perfectDrawEnabled: false,
                      //shadowForStrokeEnabled: false,
                    }
                                      }, null, 8, ["config"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_layer, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_group, { config: {
                      name: 'anchorGroup',
                      x: 50,
                      y: 50,
                      draggable: true,
                    } }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_circle, { config: {
                        x: 40,
                        y: 40,
                        radius: 5,
                        stroke: 'white',
                        fill: 'black',
                        opacity: 0.8,
                        strokeWidth: 1,
                      } }),
                                        _createVNode(_component_v_circle, { config: {
                        x: 0,
                        y: 0,
                        radius: 500,
                        fill: 'transparent',
                        perfectDrawEnabled: false,
                        shadowForStrokeEnabled: false,
                      } }),
                                        _createVNode(_component_v_circle, { config: {
                        x: 0,
                        y: 0,
                        radius: 30,
                        fill: 'transparent',
                        stroke: 'black',
                        strokeWidth: 4,
                        perfectDrawEnabled: false,
                        shadowForStrokeEnabled: false,
                      } }),
                                        _createVNode(_component_v_circle, {
                                          config: {
                        id: 'anchorPoint',
                        x: 0,
                        y: 0,
                        radius: _ctx.canvas.anchorPointRadius,
                        fill: 'red',
                        stroke: 'white',
                        strokeWidth: 1,
                        perfectDrawEnabled: false,
                        shadowForStrokeEnabled: false,
                      }
                                        }, null, 8, ["config"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["style", "config", "onMousedown", "onTouchstart", "onMousemove", "onTouchmove", "onMouseup", "onTouchend"])
                          ])
                        ], 4),
                        _withDirectives(_createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ion_button, {
                            fill: "solid",
                            color: "secondary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCompleteRelocateAnchorPoint()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('completeRelocateAnchorPoint')) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.arrowForward
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.canvas.isRelocatingAnchorPoint]
                        ])
                      ]))
                ], 512), [
                  [_vShow, _ctx.rembgMode == 'manual']
                ]),
                _withDirectives(_createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ion_buttons, { slot: "start" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.undo())),
                          disabled: _ctx.appHistory.step == -1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.arrowUndoOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redo())),
                          disabled: _ctx.appHistory.states.length == 0 || _ctx.appHistory.step >= _ctx.appHistory.states.length-1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.arrowRedoOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !_ctx.canvas.isRelocatingAnchorPoint]
                    ]),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_ion_button, {
                          size: "large",
                          fill: "solid",
                          color: "success",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToStickerDetailPage(_ctx.stickerId)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('done')) + " ", 1),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.checkmark
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.rembgMode != 'manual' || !_ctx.canvas.isRelocatingAnchorPoint]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.rembgMode == 'original' || (_ctx.rembgMode == 'auto' ? !_ctx.canvas.loadingRembgImg : !_ctx.canvas.loading)]
                ])
              ], 512), [
                [_vShow, _ctx.canvas.croppedImgDataURL != '']
              ])
            ]))
      ]),
      _: 1
    })
  ], 64))
}